import { ReactElement } from 'react';

export enum LegacyUIModule {
  Workspace = 'workspace',
  Home = 'modules',
  People = 'people',
  Rewarding = 'rewarding',
  Performance = 'performance',
  Development = 'development',
  Analytics = 'analytics',
  Collaboration = 'collaboration',
  Organization = 'organization',
  Recruiting = 'recruiting',
  Planning = 'planning',
}

export enum LegacyUIModuleVersion {
  LegacyV2 = 'legacyV2',
  LegacyUI = 'legacyUI',
}

export enum LegacyUiModuleFAIcon {
  OldHome = 'fa-th',
  Home = 'fa-home',
  People = 'fa-user',
  Rewarding = 'fa-usd',
  Performance = 'fa-check-square-o',
  Development = 'fa-line-chart',
  Analytics = 'fa-bar-chart',
  Collaboration = 'fa-cogs',
  Organization = 'fa-sitemap',
  Recruiting = 'fa-pencil-square-o',
  Planning = 'fa-calendar',
}

type NavInfo = {
  module: LegacyUIModule;
  title: string;
  faIcon?: LegacyUiModuleFAIcon;
  customIcon?: ReactElement;
  color?: string;
  disabled?: boolean;
  hidden?: boolean;
};

type NavPathVersions = {
  version?: LegacyUIModuleVersion;
  legacyV2?: {
    path: string;
  };
  legacyUI?: {
    path: string;
  };
};

type NavPaths = {
  path: string;
  href: string;
};

export type LegacyModuleNavigationItemConfig = NavInfo & NavPathVersions;

export type LegacyModuleNavigationItem = NavInfo & NavPaths;
